var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"options":_vm.options,"server-items-length":_vm.total,"footer-props":{
        itemsPerPageOptions: [2, 10, 25, 50]
    },"loading":_vm.isFetch,"loading-text":"Загрузка данных... Ожидайте"},on:{"update:options":[function($event){_vm.options=$event},_vm.onOptionsUpdate]},scopedSlots:_vm._u([{key:"item.data",fn:function(ref){
    var item = ref.item;
return [_c('pre',[_vm._v(_vm._s(JSON.stringify(item, null, 2)))])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }